

const ENBusinessDiagnostics = {
	"Adicionar Diagnóstico": "Add Diagnostic",
	"Alterar Diagnóstico": "Update Diagnostic",
	"Comparativos alterados com sucesso": "Comparisons successfully updated",
	"Comparativos": "Comparisons",
	"Comparativo": "Comparison",
	"Complemento": "Complement",
	"Deseja realmente excluir o diagnóstico": "Do you really want to delete the Business Diagnostic",
	"Diagnóstico adicionado com sucesso": "Business Diagnostic successfully added",
	"Diagnóstico alterado com sucesso": "Business Diagnostic successfully updated",
	"Diagnóstico excluído com sucesso": "Business Diagnostic successfully deleted",
	"Diagnóstico": "Diagnostic",
	"Diagnósticos": "Diagnostics",
	"Diagnósticos de Negócio": "Business Diagnostics",
	"Diagnósticos de negócio": "Business diagnostics",
	"Diagnóstico movido com sucesso": "Business Diagnostic successfully moved",
	"Digite o nome do diagnóstico para excluí-lo": "Enter the name of the Business Diagnostic to delete it",
	"Editar Diagnóstico": "Change Diagnostic",
	"Erro ao adicionar diagnóstico": "Error adding Business Diagnostic",
	"Erro ao alterar comparativos": "Error updating comparisons",
	"Erro ao alterar diagnóstico": "Error updating Business Diagnostic",
	"Erro ao atualizar comparativo, favor atualizar a pagina": "Error updating comparison, please refresh the page",
	"Erro ao excluir diagnóstico": "Error deleting Business Diagnostic",
	"Erro ao salvar respostas": "Error saving answers",
	"Erro ao atualizar diagnóstico": "Error updating Business Diagnostic",
	"Excluir Comparativo": "Delete Comparison",
	"Exclusão de diagnóstico": "Delete Business Diagnostic",
	"máximos": "maximum",
	"Modelo de diagnóstico de negócio": "Business Diagnostic model",
	"Modelo de diagnóstico é requerido": "Business Diagnostic model is required",
	"Mover Dianóstico": "Move Business Diagnostic",
	"Mover Comparativo": "Move Comparison",
	"Nenhum comparativo encontrado": "No comparison found",
	"Nenhum comparativo adicionado": "No comparison added",
	"Nenhum Diagnóstico de Negócio selecionado": "No Business Diagnostic selected",
	"Nome do diagnóstico não confere": "Business Diagnostic name does not match",
	"Novo Comparativo": "New Comparison",
	"Obtido": "Obtained",
	"Pontuação deve ser menor ou igual a pontuação máxima": "Score must be less or equal to maximum score",
	"Pontuação máxima": "Maximum score",
	"Pontuação obtida": "Score obtained",
	"Pontuação": "Score",
	"realizados de": "performed out of",
	"Realização": "Perform",
	"Resumo": "Summary",
	"Respostas salvas com sucesso": "Answers saved successfully",
	"Selecione uma diagnóstico para ver seus detalhes": "Select a Business Diagnostic to see its details",
	"Texto informativo": "Information text"
};

export default ENBusinessDiagnostics;
